
$_GP.formSearchFilter = function(elm, opt) {

	elm = $(elm);
	if (!elm.length) return;

	toggler  = elm.find(opt.toggler);
	dpStart  =  elm.find(opt.dpStart);
	dpEnd    =  elm.find(opt.dpEnd);

	var changeDatepiker = function () {
		var data = toggler.find('option:selected').data('datepicker');
		dpStart.add(dpEnd).prop('disabled', true).val('');

		if (!data) return;

		dpStart.prop('disabled', false);

		data.forEach(function(e) {
			elm.find('[name="'+ e.elm +'"]')
				.datepicker('option', 'maxDate', (e.opt.maxDate || null) )
				.datepicker('option', 'minDate', (e.opt.minDate || null) );
		});
	};

	$(window).on('load', changeDatepiker);

	toggler.change(changeDatepiker);
};
